import { Typography } from "@mui/material";

interface Props {
  errorMessage: string;
}

const ReportIsNotValid = ({ errorMessage }: Props) => {
  return (
    <Typography variant="subtitle2" color="error" noWrap>
      {errorMessage}
    </Typography>
  );
};

export default ReportIsNotValid;
